<div #container></div>
<ng-container *ngIf="(_bottomCount | async) === 0 && (hasDateFilter ? (_topCount | async) === 0 : true); else emptySpaceTemplate" (scroll)="onScroll($event)">
    <ng-content></ng-content>
</ng-container>
<ng-template #emptySpaceTemplate>
    <div #emptySpace class="position-relative"></div>
</ng-template>
